import React from 'react'
import { connect } from 'react-redux'
import { updateCalculatorAction, batchUpdateCalculatorAction } from 'actions/calculatorActions'
import { updateUiAction } from 'actions/uiActions'
import { changeCameraModelAction } from 'actions/cameraActions'
import FovModeButtonBar from './FovModeButtonBar'
import FovImage from './FovImage'
import SceneSelector from 'components/SceneSelector'
import sceneUrl from 'helpers/fovPreview/sceneUrl'
import injectSheet from 'react-jss'
import style from './style'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'

const mapStateToProps = ({ cameras, presentationValues, ui, cameraModels }) => ({
  currentCamera: getCurrentCamera(cameras),
  presentationValues,
  showSceneSelector: !!ui.showSceneSelector,
  cameraModels
})

const fovImageProps = ({ fovMode, horizontalAngleOfView, verticalAngleOfView, horizontalResolution, verticalResolution, id, backgroundPosition, streetViewActive, streetViewAvailable, userUploadedSceneActive }) => (
  { fovMode, horizontalAngleOfView, verticalAngleOfView, horizontalResolution, verticalResolution, id, backgroundPosition, streetViewActive, streetViewAvailable, userUploadedSceneActive }
)

class FovPreview extends React.Component {
  constructor(props) {
    super(props)
    this.toggleSceneSelectorComponent = this.toggleSceneSelectorComponent.bind(this)
    this.updateScene = this.updateScene.bind(this)
  }

  updateScene({ sceneName }) {
    const { props: { batchUpdateCalculatorAction, currentCamera: { id } } } = this
    if (sceneName) {
      batchUpdateCalculatorAction({ streetViewActive: false, userUploadedSceneActive: false, userSelectedGeneralScene: true, sceneName }, ['streetViewActive', 'userUploadedSceneActive', 'userSelectedGeneralScene', 'sceneName'], id, false)
    } else {
      batchUpdateCalculatorAction({ streetViewActive: true, userUploadedSceneActive: false, userSelectedGeneralScene: false }, ['streetViewActive', 'userUploadedSceneActive', 'userSelectedGeneralScene'], id, false)
    }
    this.props.updateUiAction({ showSceneSelector: false })
  }

  toggleSceneSelectorComponent() {
    this.props.updateUiAction({ showSceneSelector: !this.props.showSceneSelector })
  }

  render() {
    const { toggleSceneSelectorComponent, updateScene,
      props: { showSceneSelector, updateCalculatorAction, batchUpdateCalculatorAction, changeCameraModelAction, currentCamera, presentationValues, cameraModels,
      currentCamera: { streetViewAvailable, streetViewUrl, streetViewActive }, classes } } = this
    return (
      <div className={classes.container}>
        {!EXPORT &&
          <FovModeButtonBar {...{
            showSceneSelector,
            currentCamera,
            updateCalculatorAction,
            toggleSceneSelectorComponent,
            presentationValues,
            changeCameraModelAction,
            cameraModels
          }} />
        }
        <SceneSelector {...{ currentScene: sceneUrl(currentCamera), updateScene,
          streetViewAvailable, streetViewUrl, toggleSceneSelectorComponent, currentCamera }} />
        <FovImage {...{
          ...fovImageProps(currentCamera),
          scene: sceneUrl(currentCamera),
          batchUpdateCalculatorAction,
          streetViewActive
        }} />
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateCalculatorAction, batchUpdateCalculatorAction, updateUiAction, changeCameraModelAction })(injectSheet(style)(FovPreview))



// WEBPACK FOOTER //
// ./src/components/FovPreview/index.js